import { configureStore } from '@reduxjs/toolkit';
import cursorReducer from './features/cursorSlice';
import featuresReducer from './features/featuresSlice';

export const store = configureStore({
  reducer: {
    curMag: cursorReducer,
    featuresMag: featuresReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
